import { BrowserRouter, Routes, Route } from "react-router-dom";
import SiteLayout from "@/components/SiteLayout";
import HomePage from "@/pages/HomePage";
import WebsitesOfferPage from "@/pages/WebsitesOfferPage";
import AskboxPage from "@/pages/AskboxPage";
import AskboxDemoPage from "@/pages/AskboxDemoPage";
import PricingPage from "@/pages/PricingPage";
import ServicesPage from "@/pages/ServicesPage";
import ProductsPage from "@/pages/ProductsPage";

function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route element={<SiteLayout />}>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/pricing" element={<PricingPage />} />
                    <Route path="/services" element={<ServicesPage />} />
                    <Route path="/products" element={<ProductsPage />} />
                    <Route path="/websites" element={<WebsitesOfferPage />} />
                    <Route path="/askbox" element={<AskboxPage />} />
                </Route>
                <Route path="/askbox/demo" element={<AskboxDemoPage />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
